import React, {PropTypes} from 'react';
import {SketchPicker} from 'react-color';
import {I18n} from 'react-redux-i18n';

class LabelStylePicker extends React.Component
{ 
  constructor(props)
  {
    super(props);

    this.state = {
      mainBorderOpen: false,
      mainBackgroundOpen: false,
      headerFontOpen: false,
      headerBackgroundOpen: false,
      detailFontOpen: false,
      detailBackgroundOpen: false,
      valueFontOpen: false,
      valueBackgroundOpen: false,
      priceFontOpen: false,
      priceBackgroundOpen: false,
      pluFontOpen: false,
      barCodeBackgroundOpen: false,
      imageBorderOpen: false,
      rightPanelOpen: false
    };
  }

  openColorPicker = (event) => {
    this.closeColorPickers();
    switch(event.target.id)
    {
      case 'mainBorder':
      {
        this.setState({mainBorderOpen: !this.state.mainBorderOpen});
        break;
      }
      case 'mainBackground':
      {
        this.setState({mainBackgroundOpen: !this.state.mainBackgroundOpen});
        break;
      }
      case 'headerFont':
      {
        this.setState({headerFontOpen: !this.state.headerFontOpen});
        break;
      }
      case 'headerBackground':
      {
        this.setState({headerBackgroundOpen: !this.state.headerBackgroundOpen});
        break;
      }
      case 'detailFont':
      {
        this.setState({detailFontOpen: !this.state.detailFontOpen});
        break;
      }
      case 'detailBackground':
      {
        this.setState({detailBackgroundOpen: !this.state.detailBackgroundOpen});
        break;
      }
      case 'valueFont':
      {
        this.setState({valueFontOpen: !this.state.valueFontOpen});
        break;
      }
      case 'valueBackground':
      {
        this.setState({valueBackgroundOpen: !this.state.valueBackgroundOpen});
        break;
      }
      case 'priceFont':
      {
        this.setState({priceFontOpen: !this.state.priceFontOpen});
        break;
      }
      case 'priceBackground':
      {
        this.setState({priceBackgroundOpen: !this.state.priceBackgroundOpen});
        break;
      }
      case 'pluFont':
      {
        this.setState({pluFontOpen: !this.state.pluFontOpen});
        break;
      }
      case 'barCodeBackground':
      {
        this.setState({barCodeBackgroundOpen: !this.state.barCodeBackgroundOpen});
        break;
      }
      case 'imageBorder': 
      {
        this.setState({imageBorderOpen: !this.state.imageBorderOpen});
        break;
      }
      case 'rightPanelBackground':
      {
        this.setState({rightPanelOpen: !this.state.rightPanelOpen});
        break;
      }
    }
    event.stopPropagation();
  }

  closeColorPickers = () => {
    const closePopups = {
      mainBorderOpen: false,
      mainBackgroundOpen: false,
      headerFontOpen: false,
      headerBackgroundOpen: false,
      detailFontOpen: false,
      detailBackgroundOpen: false,
      valueFontOpen: false,
      valueBackgroundOpen: false,
      priceFontOpen: false,
      priceBackgroundOpen: false,
      pluFontOpen: false,
      barCodeBackgroundOpen: false,
      imageBorderOpen: false,
      rightPanelOpen: false
    };
    this.setState(closePopups);
  }

  handleColorChange = (name) => (color) => {
    this.props.onColorChange(name, color);
  }

  blockClosing = (event) => {
    event.stopPropagation();
  }

  render() {
    const {columnCount, logoUrl, onLogoUpload, onRestoreDefault, styleElements} = this.props;

    const labelBorderColor = {backgroundColor: styleElements.labelBorderColor};
    const labelBorderColorCode = styleElements.labelBorderColor;
    const labelBgColor = {backgroundColor: styleElements.labelBgColor};
    const labelBgColorCode = styleElements.labelBgColor;
    const headerBgColor = {backgroundColor: styleElements.headerBgColor};
    const headerBgColorCode = styleElements.headerBgColor;
    const headerFontColor = {backgroundColor: styleElements.headerFontColor};
    const headerFontColorCode = styleElements.headerFontColor;
    const detailBgColor = {backgroundColor: styleElements.detailBgColor};
    const detailBgColorCode = styleElements.detailBgColor;
    const detailFontColor = {backgroundColor: styleElements.detailFontColor};
    const detailFontColorCode = styleElements.detailFontColor;
    const valueBgColor = {backgroundColor: styleElements.valueBgColor};
    const valueBgColorCode = styleElements.valueBgColor;
    const valueFontColor = {backgroundColor: styleElements.valueFontColor};
    const valueFontColorCode = styleElements.valueFontColor;
    const priceBgColor = {backgroundColor: styleElements.priceBgColor};
    const priceBgColorCode = styleElements.priceBgColor;
    const priceFontColor = {backgroundColor: styleElements.priceFontColor};
    const priceFontColorCode = styleElements.priceFontColor;
    const pluFontColor = {backgroundColor: styleElements.pluFontColor};
    const pluFontColorCode = styleElements.pluFontColor;
    const barCodeBgColor = {backgroundColor: styleElements.barCodeBgColor};
    const barCodeBgColorCode = styleElements.barCodeBgColor;
    const imageBorderColor = {backgroundColor: styleElements.imageBorderColor};
    const imageBorderColorCode = styleElements.imageBorderColor;
    const rightPanelBgColor = {backgroundColor: styleElements.rightPanelBgColor};
    const rightPanelColorCode = styleElements.rightPanelBgColor;

    return (
      <div className="customize-body">
        <div className="row no-gutters">
          <div className="col-sm-6">
            <h5>{I18n.t('MAIN')}</h5>
            {columnCount === 0 && <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BORDER')}
              </span>
              <div className="attribute-color-box" id="mainBorder" onClick={this.openColorPicker}>
                <div className="color-box" id="mainBorder" style={labelBorderColor}/>
                <div className="color-box-label" id="mainBorder">{labelBorderColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.mainBorderOpen && <SketchPicker color={labelBorderColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('mainBorder')}/>}</div>
            </div>}
            {columnCount === 1 && <div className="float-left">
              <span className="attribute-title">
                {I18n.t('IMAGE_BORDER')}
              </span>
              <div className="attribute-color-box" id="imageBorder" onClick={this.openColorPicker}>
                <div className="color-box" id="imageBorder" style={imageBorderColor}/>
                <div className="color-box-label" id="imageBorder">{imageBorderColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.imageBorderOpen && <SketchPicker color={imageBorderColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('imageBorder')}/>}</div>
            </div>}
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BACKGROUND')}
              </span>
              <div className="attribute-color-box" id="mainBackground" onClick={this.openColorPicker}>
                <div className="color-box" id="mainBackground" style={labelBgColor}/>
                <div className="color-box-label" id="mainBackground">{labelBgColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.mainBackgroundOpen && <SketchPicker color={labelBgColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('mainBackground')}/>}</div>
            </div>
          </div>
          <div className="col-sm-6">
            <h5>{I18n.t('TITLE')}</h5>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('TEXT')}
              </span>
              <div className="attribute-color-box" id="headerFont" onClick={this.openColorPicker}>
                <div className="color-box" id="headerFont" style={headerFontColor}/>
                <div className="color-box-label" id="headerFont">{headerFontColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.headerFontOpen && <SketchPicker color={headerFontColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('headerFont')}/>}</div>
            </div>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BACKGROUND')}
              </span>
              <div className="attribute-color-box" id="headerBackground" onClick={this.openColorPicker}>
                <div className="color-box" id="headerBackground" style={headerBgColor}/>
                <div className="color-box-label" id="headerBackground">{headerBgColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.headerBackgroundOpen && <SketchPicker color={headerBgColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('headerBackground')}/>}</div>
            </div>
          </div>

          <div className="col-sm-6">
            <h5>{I18n.t('DETAIL')}</h5>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('TEXT')}
              </span>
              <div className="attribute-color-box" id="detailFont" onClick={this.openColorPicker}>
                <div className="color-box" id="detailFont" style={detailFontColor}/>
                <div className="color-box-label" id="detailFont">{detailFontColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.detailFontOpen && <SketchPicker color={detailFontColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('detailFont')}/>}</div>
            </div>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BACKGROUND')}
              </span>
              <div className="attribute-color-box" id="detailBackground" onClick={this.openColorPicker}>
                <div className="color-box" id="detailBackground" style={detailBgColor}/>
                <div className="color-box-label" id="detailBackground">{detailBgColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.detailBackgroundOpen && <SketchPicker color={detailBgColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('detailBackground')}/>}</div>
            </div>
          </div>
          <div className="col-sm-6">
            <h5>{I18n.t('LABEL')}</h5>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('TEXT')}
              </span>
              <div className="attribute-color-box" id="valueFont" onClick={this.openColorPicker}>
                <div className="color-box" id="valueFont" style={valueFontColor}/>
                <div className="color-box-label" id="valueFont">{valueFontColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.valueFontOpen && <SketchPicker color={valueFontColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('valueFont')}/>}</div>
            </div>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BACKGROUND')}
              </span>
              <div className="attribute-color-box" id="valueBackground" onClick={this.openColorPicker}>
                <div className="color-box" id="valueBackground" style={valueBgColor}/>
                <div className="color-box-label" id="valueBackground">{valueBgColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.valueBackgroundOpen && <SketchPicker color={valueBgColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('valueBackground')}/>}</div>
            </div>
          </div>
         
          <div className="col-sm-6">
            <h5>{I18n.t('PRICE')}</h5>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('TEXT')}
              </span>
              <div className="attribute-color-box" id="priceFont" onClick={this.openColorPicker}>
                <div className="color-box" id="priceFont" style={priceFontColor}/>
                <div className="color-box-label" id="priceFont">{priceFontColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.priceFontOpen && <SketchPicker color={priceFontColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('priceFont')}/>}</div>
            </div>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BACKGROUND')}
              </span>
              <div className="attribute-color-box" id="priceBackground" onClick={this.openColorPicker}>
                <div className="color-box" id="priceBackground" style={priceBgColor}/>
                <div className="color-box-label" id="priceBackground">{priceBgColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.priceBackgroundOpen && <SketchPicker color={priceBgColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('priceBackground')}/>}</div>
            </div>
          </div>
          {columnCount === 1 && <div className="col-sm-6">
            <h5>{I18n.t('PLU')}</h5>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('TEXT')}
              </span>
              <div className="attribute-color-box" id="pluFont" onClick={this.openColorPicker}>
                <div className="color-box" id="pluFont" style={pluFontColor}/>
                <div className="color-box-label" id="pluFont">{pluFontColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.pluFontOpen && <SketchPicker color={pluFontColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('pluFont')}/>}</div>
            </div>
          </div>}
          {columnCount === 1 && <div className="col-sm-6">
            <h5>{I18n.t('BARCODE')}</h5>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BACKGROUND')}
              </span>
              <div className="attribute-color-box" id="barCodeBackground" onClick={this.openColorPicker}>
                <div className="color-box" id="barCodeBackground" style={barCodeBgColor}/>
                <div className="color-box-label" id="barCodeBackground">{barCodeBgColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.barCodeBackgroundOpen && <SketchPicker color={barCodeBgColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('barCodeBackground')}/>}</div>
            </div>
          </div>}
          {(columnCount === 1 && rightPanelColorCode !== undefined) && <div className="col-sm-6">
            <h5>{I18n.t('RIGHTCOLUMN')}</h5>
            <div className="float-left">
              <span className="attribute-title">
                {I18n.t('BACKGROUND')}
              </span>
              <div className="attribute-color-box" id="rightPanelBackground" onClick={this.openColorPicker}>
                <div className="color-box" id="rightPanelBackground" style={rightPanelBgColor}/>
                <div className="color-box-label" id="rightPanelBackground">{rightPanelColorCode}</div>
              </div>
              <div onClick={this.blockClosing}>{this.state.rightPanelOpen && <SketchPicker color={rightPanelColorCode} 
                                                          disableAlpha={true}
                                                          onChange={this.handleColorChange('rightPanelBackground')}/>}</div>
            </div>
          </div>}
          <div className="col-sm-6">
            {rightPanelColorCode === undefined && <button className="btn btn-link" onClick={onRestoreDefault}>{I18n.t('RESTORE_DEFAULT_COLORS')}</button>}
            {rightPanelColorCode !== undefined && <button className="margin-four-col-lrg btn btn-link" onClick={onRestoreDefault}>{I18n.t('RESTORE_DEFAULT_COLORS')}</button>}
          </div>
        </div>
        <div className="row customize-logo no-gutters">
          <div className="col-sm-6 pr-4">
            <h5>{I18n.t('LOGO')}</h5>
            <div className="company-logo">
                <img src={logoUrl} alt="Company Logo" title="Company Logo" />
              </div>
          </div>
          <div className="col-sm-6 mt-4">
            <label className="custom-file">
              <input type="file" id="file" className="custom-file-input" accept="image/jpeg, image/png" onChange={(e) => {onLogoUpload(e.target.files[0]);}}/>
              <span className="custom-file-control">{I18n.t('UPLOAD_LOGO')}</span>
            </label>
            <span className="attribute-title">{I18n.t('LOGO_FORMAT')}</span>
          </div>
        </div>
      </div>       
    );
  }
}

LabelStylePicker.propTypes = {
  columnCount: PropTypes.number.isRequired,
  logoUrl: PropTypes.string.isRequired,
  onColorChange: PropTypes.func.isRequired,
  onLogoUpload: PropTypes.func.isRequired,
  onRestoreDefault: PropTypes.func.isRequired,
  styleElements: PropTypes.object.isRequired
};

export default LabelStylePicker;



/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelStylePicker.js
 **/